import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Imagens meramente ilustrativas", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "preco" }
const _hoisted_5 = { class: "centavos" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Informações do produto")
const _hoisted_7 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Adicionar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_PinchScrollZoom = _resolveComponent("PinchScrollZoom")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    trigger: _ctx.produto.id_jau,
    ref: "modal_produtos",
    "backdrop-dismiss": true,
    canDismiss: true,
    "is-open": _ctx.show && _ctx.open,
    onIonModalDidPresent: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toShow())),
    onIonModalDidDismiss: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toDismis())),
    "initial-breakpoint": 0.95
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding produto_show" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open=false)),
                class: "ion-text-center",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "ion-text-center",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center small",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PinchScrollZoom, {
                            ref: "zoomer",
                            height: 240,
                            scale: _ctx.scale.zoom,
                            originX: _ctx.scale.originX,
                            originY: 0,
                            translateX: 0,
                            translateY: 0,
                            within: false,
                            disablePan: false,
                            draggable: _ctx.scale.draggable,
                            enableDragging: true
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    class: "produto-imagem",
                                    src: _ctx.img
                                  }, null, 8, _hoisted_1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["scale", "originX", "draggable"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center small",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toZoom())),
                            icon: _ctx.expandOutline,
                            size: "large"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "ion-text-center small",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "ion-text-center descricao",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.produto.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "ion-text-center codigo small",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Código: " + _toDisplayString(_ctx.produto.id_jau), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "ion-text-center precofull",
                size: "12"
              }, {
                default: _withCtx(() => [
                  (_ctx.produto.price_from)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$cart.currencyUSD(_ctx.produto.price_from)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.$cart.currencyUP(_ctx.produto.price)[0]) + ",", 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$cart.currencyUP(_ctx.produto.price)[1]), 1)
                  ])
                ]),
                _: 1
              }),
              (!!_ctx.produto.prices_info.priceKg)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    size: "12",
                    class: "unidade"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Preço por Kg: " + _toDisplayString(_ctx.produto.prices_info.priceKg), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.produto.short_description)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 1,
                    class: "short_descricao",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_accordion_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_accordion, { value: "first" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, { slot: "header" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.produto.short_description), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_footer, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "7" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-align-items-center ion-nopadding" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$cart.doAddMainMinus(_ctx.produto))),
                                expand: "full",
                                size: "small",
                                fill: "#fff"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    color: "jauservelayout",
                                    slot: "icon-only",
                                    icon: _ctx.removeCircleOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                class: "item_qtd_produto_main font-montserrat-bold",
                                modelValue: _ctx.produto.qtd,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.produto.qtd) = $event)),
                                onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$cart.doSetCartQtd(_ctx.produto, _ctx.produto.qtd)), ["enter"])),
                                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.produto.qtd=$event.target.value)),
                                placeholder: "0"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$cart.doAddMainPlus(_ctx.produto))),
                                expand: "full",
                                size: "small",
                                color: "danger",
                                fill: "#fff"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    color: "jauservelayout",
                                    slot: "icon-only",
                                    icon: _ctx.addCircleOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "5",
                    class: "ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$cart.doSetCartQtd(_ctx.produto, _ctx.produto.qtd);_ctx.open=false}),
                        size: "large",
                        shape: "jau",
                        color: "jauservelayoutalter"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["trigger", "is-open", "initial-breakpoint"]))
}